import { render, staticRenderFns } from "./trafficFlowPerHour.vue?vue&type=template&id=036215b6"
import script from "./trafficFlowPerHour.vue?vue&type=script&lang=js"
export * from "./trafficFlowPerHour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports